import React, { useState } from "react";

import { AlertV4, ButtonV4, FieldV4, ModalV4, SelectV4 } from "../common/ui";

import { CANCEL_TYPES, type CancelType, type ListRow } from "./appointmentModelV4";

type ModalCancelAppointmentV4Props = {
  row: ListRow;
  busy: boolean;
  error?: unknown;
  onClose: () => void;
  onConfirm: (type: CancelType, reason: string) => void;
};

const CANCEL_OPTIONS = CANCEL_TYPES.map((value) => ({ value, text: value }));

/** ยกเลิกนัด: CONFIRM_APPOINTMENT ต้องมีผู้ขอยกเลิก (status 5/6) + เหตุผล */
const ModalCancelAppointmentV4 = (props: ModalCancelAppointmentV4Props) => {
  const [type, setType] = useState<CancelType>(CANCEL_TYPES[0]);
  const [reason, setReason] = useState("");
  const [missing, setMissing] = useState(false);

  const reasonMissing = missing && !reason.trim();

  // Handler
  const handleChangeType = (value: string) => {
    setType(value as CancelType);
  };

  const handleChangeReason = (e: React.ChangeEvent<HTMLTextAreaElement>) => {
    setReason(e.target.value);
  };

  const handleConfirm = () => {
    if (!reason.trim()) {
      setMissing(true);

      return;
    }

    props.onConfirm(type, reason.trim());
  };

  // Render
  return (
    <div className="hv4-appt-modal">
      <ModalV4 title={`ยกเลิกนัดหมาย ${props.row.id}`} width={480} onClose={props.onClose}>
        <div className="hv4-appt-modal-body">
          <div className="hv4-appt-sub">
            {props.row.name} · {props.row.when} · {props.row.provider}
          </div>
          <FieldV4 label="ผู้ขอยกเลิก" htmlFor="hv4-appt-cancel-type">
            <SelectV4
              id="hv4-appt-cancel-type"
              options={CANCEL_OPTIONS}
              value={type}
              onChange={handleChangeType}
            />
          </FieldV4>
          <FieldV4 label="เหตุผลการยกเลิก *" htmlFor="hv4-appt-cancel-reason">
            <textarea
              id="hv4-appt-cancel-reason"
              className="hv4-input hv4-textarea"
              rows={3}
              placeholder="กรุณาระบุเหตุผลในการยกเลิกนัดหมาย"
              aria-invalid={reasonMissing}
              value={reason}
              onChange={handleChangeReason}
            />
          </FieldV4>
          {reasonMissing && <AlertV4 tone="danger">กรุณาระบุเหตุผลในการยกเลิกนัดหมาย</AlertV4>}
          <AlertV4 tone="danger" error={props.error} />
        </div>
        <div className="hv4-appt-modal-foot">
          <ButtonV4 className="hv4-appt-modal-close" onClick={props.onClose}>
            ปิดหน้าจอ
          </ButtonV4>
          <ButtonV4 className="hv4-appt-modal-save" disabled={props.busy} onClick={handleConfirm}>
            ยกเลิกนัด
          </ButtonV4>
        </div>
      </ModalV4>
    </div>
  );
};

ModalCancelAppointmentV4.displayName = "ModalCancelAppointmentV4";

export default ModalCancelAppointmentV4;
